<template>
  <div
    class="w-screen h-screen bg-gray-300 flex items-center justify-center bg-opacity-20 fixed top-0 left-0"
    v-if="!inner"
  >
    <span class="loader" :class="dark ? 'dark' : ''"></span>
  </div>
  <div v-else class="lds-dual-ring mx-auto"></div>
</template>

<script setup>
  defineProps({
    inner: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  })
</script>

<style scoped>
  .loader {
    width: 108px;
    height: 108px;
    border-radius: 50%;
    display: inline-block;
    border: 5px solid;
    box-sizing: border-box;
    border-color: #fff #fff transparent;
    animation: rotation 1s linear infinite;
  }

  .loader.dark {
    border-color: #d1d5db #d1d5db transparent;
  }

  .loader::after {
    content: "";
    box-sizing: border-box;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    border: 5px solid;
    border-color: transparent rgb(99, 70, 20);
    width: 60px;
    height: 60px;
    border-radius: 50%;
    animation: rotationBack 0.5s linear infinite;
    transform-origin: center center;
  }

  .loader.xs {
    width: 20px;
    height: 20px;
  }

  .loader.xs::after {
    width: 12px;
    height: 12px;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes rotationBack {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(-360deg);
    }
  }

  .lds-dual-ring {
    display: block;
    width: 17px;
    height: 17px;
    border-radius: 50%;
    border: 2px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: lds-dual-ring 0.7s linear infinite;
  }

  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
</style>
